'use client';
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
const UnreadOffersBadge = ({ unreadOffersCount })=>unreadOffersCount > 0 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "ptw-relative",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            style: {
                left: '20px',
                bottom: '-10px'
            },
            className: "ptw-absolute",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                style: {
                    border: 'solid 2px white',
                    backgroundColor: '#E91C24'
                },
                className: "ptw-flex ptw-size-fit ptw-h-[16px] ptw-items-center ptw-justify-center ptw-rounded-pill ptw-px-2 ptw-py-2 ptw-text-body-sm ptw-text-primary-text",
                children: [
                    unreadOffersCount > 99 ? '99+' : unreadOffersCount,
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                        style: {
                            visibility: 'hidden',
                            width: '0px'
                        },
                        children: " unread messages"
                    })
                ]
            })
        })
    });
const UnreadOffers_UnreadOffersBadge = UnreadOffersBadge;
export { UnreadOffers_UnreadOffersBadge as default };
